import { hotelData } from '../../../mocks/hotelData';

export default function Location() {
  return (
    <div className="mb-8">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">위치</h2>
      
      <div className="bg-gray-50 rounded-lg p-6 mb-6">
        <div className="flex items-start gap-3 mb-4">
          <i className="ri-map-pin-line text-teal-600 text-xl mt-1"></i>
          <div>
            <p className="font-medium text-gray-900 mb-1">{hotelData.location}</p>
            <p className="text-sm text-gray-600">동대문 디자인 플라자 인근</p>
          </div>
        </div>
        
        <div className="w-full h-64 bg-gray-200 rounded-lg overflow-hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.5447891234567!2d127.00789!3d37.56682!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDM0JzAwLjYiTiAxMjfCsDAwJzI4LjQiRQ!5e0!3m2!1sko!2skr!4v1234567890"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      <div>
        <h3 className="text-lg font-bold text-gray-900 mb-4">주변 명소</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {hotelData.nearbyAttractions.map((attraction, index) => (
            <div key={index} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
              <div>
                <p className="font-medium text-gray-900 mb-1">{attraction.name}</p>
                <p className="text-sm text-gray-600">{attraction.time}</p>
              </div>
              <div className="text-sm font-medium text-teal-600">{attraction.distance}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}